import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkedlilnk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.75229 9.24771L2.96654 11.0335C1.88045 12.1195 1.88045 13.8805 2.96654 14.9665L4.15883 16.1588C5.24492 17.2449 7.00582 17.2449 8.09191 16.1588L11.4504 12.8004C12.5364 11.7143 12.5364 9.9534 11.4504 8.86731L10.7891 8.20606",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.6012 9.64975L16.387 7.864C17.4731 6.77791 17.4731 5.01701 16.387 3.93092L15.1947 2.73863C14.1086 1.65254 12.3477 1.65254 11.2616 2.73863L7.90316 6.09707C6.81707 7.18316 6.81707 8.94406 7.90316 10.0302L8.56441 10.6914",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgSkedlilnk;
